class SupplyMeMembershipComparison {
  constructor(root) {
    this.root = root;
    const requestedTerm = new URLSearchParams(window.location.search).get('term');
    this.requestedTerm = ['annual', 'lifetime'].includes(requestedTerm?.toLowerCase())
      ? requestedTerm.toLowerCase()
      : null;
    root.querySelectorAll('[data-plan-card]').forEach((card) => this.initCard(card));
    root.querySelectorAll('[data-direct-checkout]').forEach((form) => this.initDirectCheckout(form));
  }

  initCard(card) {
    const controls = card.querySelectorAll('[data-term-control]');
    const panels = card.querySelectorAll('[data-term-panel]');
    const media = card.querySelectorAll('[data-term-media]');
    const showTerm = (term) => {
      controls.forEach((control) => {
        control.checked = control.value === term;
      });
      panels.forEach((panel) => {
        const isActive = panel.dataset.termPanel === term;
        panel.hidden = !isActive;
        panel.querySelectorAll('button, input').forEach((element) => {
          if (element.name !== 'id' && element.name !== 'selling_plan') return;
          element.disabled = !isActive;
        });
      });
      media.forEach((item) => {
        item.hidden = item.dataset.termMedia !== term;
      });
    };

    controls.forEach((control) => {
      control.addEventListener('change', () => showTerm(control.value));
    });
    showTerm(this.requestedTerm || card.dataset.defaultTerm || 'annual');
  }

  initDirectCheckout(form) {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const button = form.querySelector('[type="submit"]');
      const originalLabel = button ? button.textContent : '';
      const variantId = form.dataset.variantId;
      const sellingPlanId = form.dataset.sellingPlanId;
      const item = { id: Number(variantId), quantity: 1 };
      if (sellingPlanId) item.selling_plan = Number(sellingPlanId);

      if (!variantId) return;
      if (button) {
        button.disabled = true;
        button.textContent = 'Taking you to checkout…';
      }

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
        if (!response.ok) throw new Error('Unable to add this pass.');
        window.location.assign(`${root}checkout`);
      } catch (error) {
        if (button) {
          button.disabled = false;
          button.textContent = originalLabel;
        }
        window.alert('We couldn’t start checkout. Please refresh the page and try again.');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sm-memberships]').forEach((root) => new SupplyMeMembershipComparison(root));
});

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('[data-sm-memberships]');
  if (root) new SupplyMeMembershipComparison(root);
});
